export const settings = {
	/**
	* Gets the programmatic name of the entire locale, with the language,
	*	country and variant separated by underbars. The Language is always lower case,
	*	and country is always upper case. If the language is missing,
	*	the string will begin with an underscore character.
	*	If both the language and country fields are missing,
	*	this function will return the empty string,
	*	even if the variant field is filled in (you cannot have a locale with just a variant--
	*	the variant must accompany a valid language or country code). Examples: "en"
	*
	*/
	en: {
		settings: 'settings',
		settings_information: 'Settings Information',
		add_settings: 'Add Settings',
		waiting_period_configuration: 'Waiting period configuration (Minimum 180s)',
		name: 'Name',
		serial_no: 'Serial No',
		add_serial_key : 'Add Serial Key',
	},

	ar: {
		settings: 'الإعدادات',
		settings_information: 'معلومات الإعدادات',
		add_settings: 'أضف الإعدادات',
		waiting_period_configuration: 'تكوين فترة الانتظار (180 ثانية كحد أدنى)',
		name: 'الاسم',
		serial_no: 'الرقم التسلسلي',
		add_serial_key : 'أضف مفتاح تسلسلي',
	}
}
